module.exports = __webpack_public_path__ + "vue/img/logo_blue.9e945e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/common/logo_blue.svg
// module id = qqFc
// module chunks = 1